
import React from 'react';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Badge } from "@/components/ui/badge";
import { File } from "lucide-react";
import { Communication } from './types';
import { getTypeIcon, getStatusBadge, formatDate } from './utils';

interface CommunicationListProps {
  communications: Communication[];
}

export const CommunicationList: React.FC<CommunicationListProps> = ({ communications }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <ScrollArea className="h-[400px]">
        <div className="divide-y">
          {communications.length === 0 ? (
            <div className="py-16 text-center text-gray-500">
              No communications matching your criteria
            </div>
          ) : (
            communications.map((comm) => (
              <div key={comm.id} className="p-4 hover:bg-gray-50 transition-colors">
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-center gap-2">
                    <div className={`p-2 rounded-full ${
                      comm.type === 'email' ? 'bg-blue-100 text-blue-600' :
                      comm.type === 'chat' ? 'bg-green-100 text-green-600' :
                      'bg-purple-100 text-purple-600'
                    }`}>
                      {getTypeIcon(comm.type)}
                    </div>
                    <div>
                      <div className="font-medium">{comm.subject}</div>
                      <div className="text-sm text-gray-500">
                        {comm.sender} → {comm.recipient}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant={comm.flagged ? "destructive" : 
                      comm.status === "archived" ? "outline" : 
                      comm.status === "pending_review" ? "secondary" : "default"}>
                      {getStatusBadge(comm.status, comm.flagged)}
                    </Badge>
                    <div className="text-xs text-gray-500 whitespace-nowrap">
                      {formatDate(comm.timestamp)}
                    </div>
                  </div>
                </div>
                <div className="pl-10 text-sm text-gray-600">
                  {comm.content.length > 100 
                    ? `${comm.content.substring(0, 100)}...` 
                    : comm.content}
                </div>
                {comm.attachments > 0 && (
                  <div className="pl-10 mt-2 text-xs text-gray-500 flex items-center gap-1">
                    <File className="h-3 w-3" />
                    {comm.attachments} {comm.attachments === 1 ? 'attachment' : 'attachments'}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
